/**
 * buildInvoiceShareText — the single source of truth for the WhatsApp/SMS text
 * that accompanies a shared invoice link. Used by both the customer card
 * (CustomerManager) and the bills page (BillingPage) so the two never drift.
 *
 * "Amount" is this invoice's own total. "Total Due" is the full outstanding
 * (this invoice + previous dues − payments) and is only included when it differs
 * from Amount — i.e. when there are previous dues or payments in play.
 *
 * @param {object} inv          invoice list item (f_total_amount, f_previous_due,
 *                              paid_amount, invoice_period_display, f_invoice_number,
 *                              payment_status)
 * @param {string} customerName customer's display name
 * @returns {string}
 */
export function buildInvoiceShareText(inv, customerName) {
    const amount = parseFloat(inv.f_total_amount) || 0;
    const totalDue = amount + parseFloat(inv.f_previous_due || 0) - parseFloat(inv.paid_amount ?? 0);
    const fmt = (n) => n.toLocaleString('en-IN', { maximumFractionDigits: 0 });
    const status = inv.payment_status === 'Paid' ? 'Paid'
        : inv.payment_status === 'Partial' ? 'Partially Paid'
            : 'Unpaid';

    const lines = [
        `Dear ${customerName || 'Customer'},`,
        `Invoice ${inv.invoice_period_display} | #${inv.f_invoice_number}`,
        `Amount: ₹${fmt(amount)}`,
    ];
    // Only show Total Due when it actually differs from Amount (previous dues / payments)
    if (Math.round(totalDue) !== Math.round(amount)) {
        lines.push(`Total Due: ₹${fmt(totalDue)}`);
    }
    lines.push(`Status: ${status}`);
    return lines.join('\n');
}
